module.exports = __webpack_public_path__ + "static/media/baseMeme11thumb.7978ed79.jpg";